<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list @form="dialog = true" @clear="$refs.form.clear()" />
        <form-manager ref="form" :dialog="dialog" @close="dialog = false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormManager from './FormManager'
import List from './List'

export default {
  name: 'TypeSubscriptions',
  components: {
    List,
    FormManager,
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.$store.dispatch('typeSubscriptions/resetState')
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      setStatus: 'events/setStatus',
      fetchTypeSubscriptions: 'typeSubscriptions/fetchList',
    }),
    async initData() {
      await Promise.all([this.fetchTypeSubscriptions({ limit: 0 })])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
  },
}
</script>
